import { environment as ENV } from '@environment';

export const recentApi = {
  home_searches_recent: `${ENV.api.services}/api/ms/travel-searches/recent`,
  home_searches_recent_delete: `${ENV.api.services}/api/ms/travel-searches/recent`,
  auto_save_searches: `${ENV.api.services}/api/ms/travel-searches/cars`,
  bus_save_searches: `${ENV.api.services}/api/ms/travel-searches/buses`,
  air_save_searches: `${ENV.api.services}/api/ms/travel-searches/flights`,
  hotel_save_searches: `${ENV.api.services}/api/ms/travel-searches/hotels`,
  air_packages_save_searches: `${ENV.api.services}/api/ms/travel-searches/packages`,
};
